<template>
  <div id="tourLogo">
    <q-card-section>
      <ImageInput
        title="Logo da Empresa"
        :hasImage="hasImage"
        :imageUrl="imageUrl"
        :loading="loadingFile"
        @fileUploaded="handleFileUpload"
        @fileRemoved="removerLogo"
      />
    </q-card-section>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import { Dialog, Notify } from "quasar";

export default {
  name: "tour-logo",
  emits: ["next"],
  data() {
    return {
      importingLogo: false,
      hasImage: false,
      imageUrl: null,
      loadingFile: false,
      errors: [],
    };
 },
  methods: {
    handleFileUpload(file) {
      if (!file) return;
      this.loadingFile = true;

      const fd = new FormData();
      fd.append("logo", file);

      axios
        .post("/empresas/edit?imagem=1", fd, { headers: { "Content-Type": "multipart/form-data" } })
        .then(res => {
          this.loadingFile = false;
          if (res.error) {
            this.avisarFalha();
            return;
          }
          if (!res.data.success) {
            if (res.data.error) {
              Dialog.create({
                title: res.data.error,
                class: "bg-negative text-white",
                ok: {
                  "text-color": "red",
                  color: "white"
                }
              });
            } else {
              Notify.create({
                message: res.data.message,
                color: "red",
                position: "top-right"
              });
            }
            return;
          }

          this.hasImage = true;
          this.imageUrl = res.data.logo;
          this.$store.commit("dataEmpresa", { ...this.$store.getters.dataEmpresa, logo_url: res.data.logo });
          Notify.create({
            message: res.data.message,
            color: "green",
            position: "top-right"
          });
        });
    },
    importLogo() {
      if (this.importingLogo) {
        return;
      }

      this.importingLogo = true;

      axios
        .post("/plano-contas/importar")
        .then(res => {
          if (!res.data.success) {
            Notify.create({
              message: "Não foi possível importar os produtos. Tente novamente mais tarde.",
              color: "red",
              position: "top-right",
            });
          }

          this.importingPlanodeContas = false;
          this.$store.dispatch("addProduto", { importar_produtos: true });
          this.productsImported = true;
        });
    },
    removerLogo() {
      Dialog.create({
        title: "Tem certeza que deseja remover a logo da empresa?",
      }).onOk(() => {
        this.loadingFile = true;

        axios
          .post("/empresas/edit?imagem=2")
          .then(res => {
            if (res.data.success) {
              Notify.create({
                message: "Logo da empresa removido com sucesso!",
                color: "green",
                position: "top-right"
              });
              this.hasImage = false;
              this.imageUrl = "";
              this.$store.commit("dataEmpresa", { ...this.$store.getters.dataEmpresa, logo_url: null });
            } else {
              Notify.create({
                message: "Houve um erro ao remover logo da empresa",
                color: "red",
                position: "top-right"
              });
              this.errors = res.data.errors;
            }
            this.loadingFile = false;
          })
          .catch(() => {
            // axios-auth resolves HTTP errors as { error }, so reading res.data lands here.
            // Released before the dialog: the image input's Loading overlay sits above it.
            this.loadingFile = false;
            this.avisarFalha();
          });
      });
    },
    avisarFalha() {
      Dialog.create({
        title:
          "Não foi Possível realizar a ação, ou você não possui permissão isto!",
        class: "bg-negative text-white",
        ok: {
          "text-color": "red",
          color: "white"
        }
      });
    },
  },
  computed: {
  },
  watch: {
  }
};
</script>
